export const Message = {
  sendTimingNames: new Map([
    ['now', '즉시'],
    ['atReservedTime', '예약'],
  ]),
  channelNames: new Map([
    ['legacy', 'SK브로드밴드'],
    ['alimTalk', '카카오 알림톡'],
    ['solapi', '솔라피'],
  ]),
};
